export default function LogoTicker() {
  const items = [
    "Salões de Beleza",
    "Spas",
    "Centros de Estética",
    "Institutos de Beleza",
    "Clínicas de Estética",
    "Clínicas de Beleza",
    "Nail Studios",
    "Centros de Bronzeamento",
    "Clínicas de Laser",
    "Studios de Sobrancelhas",
  ];

  const list = [...items, ...items];

  return (
    <section
      data-testid="logo-ticker"
      className="relative py-8 sm:py-10 border-y border-white/[0.04] bg-[#070E1A]/40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-4">
        <p className="text-xs uppercase tracking-[0.25em] text-slate-500">
          Feito para negócios de estética e beleza
        </p>
      </div>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#050B14] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#050B14] to-transparent z-10 pointer-events-none" />
        <div className="ticker flex gap-8 sm:gap-12 whitespace-nowrap text-xl sm:text-2xl md:text-3xl font-medium text-slate-500/70" style={{ width: "max-content" }}>
          {list.map((item, i) => (
            <div key={i} className="flex items-center gap-8 sm:gap-12">
              <span className="hover:text-blue-300 transition-colors">{item}</span>
              <span className="text-slate-700">·</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
